function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgGraphPlaceholder = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 264 300",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 300,
    rx: 11.98,
    style: {
      fill: "#e2e3ed"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 20,
    width: 32,
    height: 280,
    rx: 11.98,
    style: {
      fill: "#e2e3ed"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    width: 32,
    height: 300,
    rx: 11.98,
    style: {
      fill: "#e2e3ed"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 165,
    width: 32,
    height: 135,
    rx: 11.98,
    style: {
      fill: "#e2e3ed"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 80,
    width: 32,
    height: 220,
    rx: 11.98,
    style: {
      fill: "#e2e3ed"
    }
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGraphPlaceholder, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/graph_placeholder.da445a64.svg";
export { ForwardRef as ReactComponent };